var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOrrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FF6000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8331 15.4166H18.1606L15.9552 17.622C15.9154 17.6604 15.8836 17.7064 15.8618 17.7573C15.84 17.8081 15.8285 17.8628 15.828 17.9181C15.8275 17.9734 15.8381 18.0283 15.859 18.0795C15.88 18.1307 15.9109 18.1772 15.95 18.2163C15.9891 18.2555 16.0357 18.2864 16.0869 18.3074C16.1381 18.3283 16.1929 18.3388 16.2483 18.3384C16.3036 18.3379 16.3583 18.3264 16.4091 18.3046C16.4599 18.2827 16.5059 18.251 16.5443 18.2112L19.461 15.2945C19.5391 15.2164 19.583 15.1104 19.583 14.9999C19.583 14.8894 19.5391 14.7835 19.461 14.7053L16.5443 11.7887C16.4658 11.7128 16.3605 11.6708 16.2513 11.6717C16.142 11.6727 16.0375 11.7165 15.9603 11.7938C15.883 11.871 15.8392 11.9755 15.8382 12.0848C15.8373 12.194 15.8793 12.2993 15.9552 12.3778L18.1606 14.5833H10.8331C10.7226 14.5833 10.6166 14.6272 10.5385 14.7053C10.4603 14.7834 10.4164 14.8894 10.4164 14.9999C10.4164 15.1104 10.4603 15.2164 10.5385 15.2946C10.6166 15.3727 10.7226 15.4166 10.8331 15.4166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOrrange);
export default __webpack_public_path__ + "static/media/arrowOrrange.7153ed871629ac54c5a774cb8ac34b88.svg";
export { ForwardRef as ReactComponent };